const payment = {
    price: 'Prijs',
    totalPrice: 'Totale Prijs',
    pricePerPerson: 'per persoon',
    // Payment Buttons
    bookTrip: 'Boek "{tripName}"',
    deposit: 'Aanbetaling: (nu te betalen)',
    balance: 'Saldo: (te betalen een maand voor de reis)',
    payDeposit: 'Betaal Aanbetaling (€{amount})',
    payBalance: 'Betaal Saldo (€{amount})',
    // Simple labels without placeholders
    depositLabel: 'Aanbetaling',
    balanceLabel: 'Saldo',
    processing: 'Verwerken...',
    securityInfo: {
        title: 'Veiligheidsinformatie',
        stripeSecure: '• Betalingen worden veilig afgehandeld door Stripe',
        noCardStorage: '• We slaan je kaartgegevens niet op',
        balanceDue: '• Het saldo moet een maand voor de reis worden betaald',
        emailConfirmation: '• Je ontvangt een bevestigingse-mail na elke betaling'
    },
    tripFullMessage: 'De reis is vol. Het is niet mogelijk om de aanbetaling te doen.',
    tripFull: 'Reis Vol',
    cannotPayTripFull: 'Kan niet betalen, de reis is al vol',

    // Payment Success
    paymentSuccess: 'Betaling succesvol voltooid!',
    trip: 'Reis',
    paymentType: 'Betalingssoort',
    amount: 'Bedrag',
    nextStep: 'Volgende stap: Het saldo moet een maand voor de reis worden betaald. Je ontvangt een melding wanneer het tijd is om de betaling te voltooien.',
    viewTrip: 'Bekijk Reis',
    viewBookings: 'Bekijk mijn boekingen',
    close: 'Sluiten',

    // User Bookings
    yourBookings: 'Jouw Boekingen',
    loadingBookings: 'Boekingen laden...',
    noBookings: 'Je hebt nog geen boekingen',
    noBookingsMessage: 'Je hebt nog geen boekingen gemaakt.',
    bookingError: 'Fout bij laden boekingen',
    retry: 'Opnieuw Proberen',
    tripDate: 'Reisdatum',
    bookedOn: 'Geboekt op',
    toBeConfirmed: 'Te bevestigen',
    paymentStatus: 'Betalingsstatus',
    total: 'Totaal',
    depositPaid: 'Betaald',
    balancePaid: 'Betaald',
    depositPending: 'In afwachting',
    balancePending: 'In afwachting',
    depositToPayNow: '(nu te betalen)',
    balanceToPayBeforeTrip: '(te betalen een maand voor de reis)',
    depositFailed: 'Mislukt',
    balanceFailed: 'Mislukt',
    confirmed: 'Bevestigd',
    pending: 'In afwachting',
    cancelled: 'Geannuleerd',

    // Payment Return
    verifyingPayment: 'Betaling verifiëren...',
    paymentVerificationError: 'Fout bij verifiëren betaling',
    paymentCancelled: 'Betaling geannuleerd',
    verifying: 'Betaling verifiëren...',
    missingSessionId: 'Sessie-ID ontbreekt. Betaling niet geldig.',
    paymentCompleted: 'Betaling Voltooid!',
    paymentSuccessMessage: 'Je betaling is succesvol verwerkt. Je ontvangt binnenkort een bevestigingse-mail.',
    backToHome: 'Terug naar Home',
    goToAccount: 'Ga naar Mijn Account',
    paymentError: 'Betalingsfout',
    contactSupport: 'Neem Contact Op voor Ondersteuning',
    invalidSession: 'Ongeldige sessie',

    // Payment Error
    paymentFailed: 'Betaling Mislukt',
    paymentFailedMessage: 'Het spijt ons, maar je betaling kon niet worden verwerkt. Probeer opnieuw of neem contact met ons op als het probleem aanhoudt.',
    paymentDetails: 'Betalingsgegevens',
    errorDetails: 'Foutdetails',
    whatToDo: 'Wat te doen:',
    checkCardDetails: 'Controleer of je kaartgegevens correct zijn',
    ensureSufficientFunds: 'Zorg dat je voldoende saldo hebt',
    tryDifferentCard: 'Probeer een andere betaalmethode',
    contactSupportIfNeeded: 'Neem contact met ons op als je problemen blijft houden',
    retryPayment: 'Probeer Betaling Opnieuw',

    // Insufficient Spots Error
    insufficientSpots: 'Sorry, Te Laat!',
    insufficientSpotsMessage: 'Het spijt ons, maar er zijn geen plaatsen meer beschikbaar voor deze reis. Er zijn nog maar {availableSpots} plaatsen over.',
    insufficientSpotsDetails: 'Helaas hebben andere reizigers hun boekingen voltooid terwijl je de betaling aan het verwerken was. Bekijk onze andere beschikbare reizen of neem contact met ons op voor hulp.',

    // Refund
    refund: {
        requestTitle: 'Restitutieverzoek',
        requestDescription: 'Je kunt alleen restitutie aanvragen voor de laatste betaling (saldo). De aanbetaling kan niet worden teruggestort.',
        trip: 'Reis',
        amount: 'Bedrag',
        reasonLabel: 'Reden voor restitutie',
        reasonPlaceholder: 'Leg uit waarom je restitutie aanvraagt...',
        reasonRequired: 'Geef een reden op voor het restitutieverzoek',
        submitRequest: 'Verstuur Verzoek',
        requestSubmitted: 'Restitutieverzoek succesvol verzonden. Je ontvangt binnenkort een bevestigingse-mail.',
        requestError: 'Fout bij verzenden restitutieverzoek. Probeer opnieuw.',
        requestStatus: 'Restitutieverzoek verzonden en in behandeling.',
        alreadyRequested: 'Restitutie al aangevraagd',
        requestPending: 'Restitutieverzoek in afwachting',
        requestApproved: 'Restitutieverzoek goedgekeurd',
        requestRejected: 'Restitutieverzoek afgewezen',
        requestProcessed: 'Restitutieverzoek verwerkt',
        refundRequests: 'Restitutieverzoeken',
        refundRequestBalance: 'Aanvraag restitutie saldo (€{amount})',
        refundRequestSentOn: 'Verzonden op: {date}',
        refundRequestProcessedOn: 'Verwerkt op: {date}',
        refundRequestNotes: 'Opmerkingen: {notes}',
        refundDepositNotAvailable: 'Restitutie van aanbetaling is niet beschikbaar. Alleen het saldo kan worden teruggestort.'
    },

    // Resume Payment
    resumeDepositPayment: 'Hervat Aanbetaling',
    resumeBalancePayment: 'Betaal laatste termijn',
    paymentPending: 'Betaling In Behandeling...',
    payDepositFirst: 'Betaal eerst de aanbetaling',

    // Account Page
    yourPayments: 'Jouw Betalingen',
    totalPaid: 'Totaal Betaald',
    notPaid: 'Niet Betaald',
    inProgress: 'In afwachting',
    completed: 'Voltooid',
    partiallyPaid: 'Gedeeltelijk Betaald',
    actions: 'Acties',
    accountActions: 'Accountacties',
    noPaymentsFound: 'Geen betalingen gevonden',
    paymentLoadingError: 'Fout bij laden betalingen',

    // Trip Details Booking Section
    bookThisTrip: 'Boek Deze Reis',
    completeBooking: 'Voltooi de boeking door de aanbetaling te betalen. Het saldo moet een maand voor de reis worden betaald.',
    depositInfo: 'De aanbetaling is 30% van de totale prijs',
    balanceInfo: 'Het saldo (70%) moet een maand voor de reis worden betaald',
    importantInfo: {
        title: 'Belangrijke Informatie',
        depositPercent: '• Aanbetaling te betalen bij boeking',
        balancePercent: '• Het saldo moet een maand voor de reis worden betaald',
        stripeSecure: '• Betalingen worden veilig afgehandeld door Stripe',
        noCardStorage: '• We slaan je creditcardgegevens niet op',
        emailConfirmation: '• Je ontvangt een bevestigingse-mail na elke betaling'
    }
};

export default payment;

